import React from "react";
import { formatValue } from "../../../components/utils/common";
import { FormatType } from "../../../entities/Metadata";

interface OwnProps {
    value: number | undefined;
    title: string;
    className?: string;
    onDoubleClick?: React.MouseEventHandler<HTMLDivElement>;
    expected?: number;
    isDayOff: boolean;
    unit?: string;
    format?: FormatType;
    emptyText?: string;
}

type Props = OwnProps;

export default function TimeTrackingCellValue(props: Props) {
    const { value, title, className, onDoubleClick, expected, isDayOff, unit, format, emptyText } = props;
    const isExceeded = expected !== undefined && !!value && value > expected;

    return (
        <div
            onDoubleClick={
                onDoubleClick
                    ? ev => {
                        onDoubleClick(ev);
                        ev.stopPropagation();
                    }
                    : undefined
            }
            className={`value-wrap ${className ?? ""} ${!value && emptyText !== undefined ? "no-data" : ""}`}
            title={title}>
            
            <div className="value">
                {expected || isExceeded
                    ?
                    <>
                        {formatValue(value!, format)} of {formatValue(expected, format)}
                    </>
                    :
                    <>
                        {value
                            ? formatValue(value, format)
                            : emptyText ?? (isDayOff
                                ? ""
                                : "-")
                        }
                    </>
                }
            </div>
            {unit && <div className="unit">{unit}</div>}
        </div>
    );
}
